import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Seo from "@/components/Seo";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Termos de Uso | Quimical"
        description="Leia os termos e condições de uso do site da Quimical, com informações sobre acesso, responsabilidade e propriedade intelectual."
        canonical="https://quimical.com.br/termos"
      />
      <Header />
      
      <main className="pt-20">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-foreground mb-8">
              Termos e Condições de Uso
            </h1>
            
            <div className="prose prose-gray max-w-none">
              <p className="text-muted-foreground mb-6">
                Última atualização: Janeiro de 2024
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  1. Aceitação dos Termos
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Ao acessar e usar este site, você aceita e concorda em cumprir os termos e condições de uso aqui estabelecidos. 
                  Se você não concordar com qualquer parte destes termos e condições, não deve usar nosso site.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  2. Sobre a Quimical
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  A Empresa Brasileira de Mercadologia LTDA, operando sob a marca Quimical, é uma empresa especializada 
                  na comercialização de cal virgem e cal hidratada para diversos segmentos industriais.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  3. Uso do Site
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Este site destina-se ao uso por pessoas físicas e jurídicas interessadas em nossos produtos e serviços. 
                  É proibido:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Usar o site para qualquer finalidade ilegal ou não autorizada</li>
                  <li>Tentar acessar áreas restritas do sistema</li>
                  <li>Interferir no funcionamento normal do site</li>
                  <li>Transmitir vírus ou códigos maliciosos</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  4. Propriedade Intelectual
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Todo o conteúdo deste site, incluindo textos, imagens, logos, marcas e design, é protegido por direitos autorais 
                  e outras leis de propriedade intelectual, sendo propriedade da Quimical ou de seus licenciadores.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  5. Portal do Cliente
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  O acesso ao Portal do Cliente é restrito a clientes autorizados e requer login e senha. 
                  O usuário é responsável por manter a confidencialidade de suas credenciais de acesso.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  6. Limitação de Responsabilidade
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  A Quimical não se responsabiliza por danos diretos ou indiretos decorrentes do uso deste site. 
                  As informações são fornecidas "como estão" e podem ser alteradas sem aviso prévio.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  7. Modificações
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Reservamo-nos o direito de modificar estes termos a qualquer momento. 
                  As alterações entrarão em vigor imediatamente após sua publicação no site.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  8. Lei Aplicável
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Estes termos são regidos pelas leis brasileiras. Qualquer disputa será resolvida nos tribunais competentes do Brasil.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  9. Contato
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Para dúvidas sobre estes termos, entre em contato conosco através do e-mail: 
                  <a href="mailto:comercial@quimical.com.br" className="text-primary hover:underline ml-1">
                    comercial@quimical.com.br
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
